<template>
	<div class="position-relative" style="z-index: 1039">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" style="bottom:0%;top: 0">
        <div class="custom-container-fluid px-0">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="bg-white">
                <div class="w-100 popup-full">
                  <div class="">
                    <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute" width="33" @click="done" style="z-index: 1038">
                    <div v-if="is_load" class="w-100 py-4 text-center">
								      <loader />
								    </div>
								    <template v-else>
								    	<p class="w-100 py-5 text-danger" v-if="error != ''">{{error}}</p>
								    	<template v-else>
		                    <img :src="product.image_url" class="object-fit w-100 img-h-header" v-if="!isProductImageHidden">
		                    <div class="container px-4" :class="isProductImageHidden ? 'pt-5 mt-4' : 'mt-3'">
		                      <div class="row no-gutters">
		                        <div :class="{'col-12' : is_variant,'col-8' : !is_variant}">
		                          <p class="mb-0 body-1-4 text-22">{{product.name}}</p>
		                        </div>
		                        <div class="col-4 text-right" v-if="!is_variant">
		                          <p class="mb-0 body-16 mt-1 font-bold text-16 text-color-orange">{{formatCurrency(final_price)}}</p>
		                        </div>
		                      </div>
		                      <p class="mb-0 mt-1 body-2-2 font-semibold">{{product.category.name}}</p>
		                      <div class="my-3 pt-2" v-if="product.description">
		                        <p class="mb-2 body-3-3 text-16 font-bold">{{$t('general.description')}}</p>
		                        <p class="mb-0 body-3-3 text-14 font-regular">{{product.description}}</p>
		                      </div>
		                      <!-- Variant -->
		                      <div class="my-3 pt-2" v-if="is_variant">
		                        <p class="mb-2 body-3-3 text-16 font-bold">{{$t('hotel.action.choose-variant')}}</p>
		                        <div class="bg-white position-relative">
		                          <div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: 0" @click="xScroll('left', 'variant')">
		                            <img src="../../../../assets/img/icon/orange-arrow-left.png" width="18" class="next-button position-relative" style="left: -23px;top: 7px;z-index: 9">
		                          </div>
		                          <div class="div-wrapper mx-auto d-inline-block m-width-100 position-relative left-0-d pb-1" id="variant" style="width: 97%;">
		                            <div class="text-center" style="width: max-content">
		                              <div class="text-center d-inline-block cursor-pointer" v-for="(data, index) in product.variant_list" @click="variant_selected = data">
		                                <div class="border_1 py-1 px-3 cursor-pointer bg-light-page mr-2 rounded-3" :class="{'delay bg-orange border-orange': variant_selected.product_ga_pos_id == data.product_ga_pos_id}">
		                                  <p class="body-2 mb-0 text-unactive text-14 font-semibold" :class="{'font-bold text-white':variant_selected.product_ga_pos_id == data.product_ga_pos_id}">{{data.name}}</p>
		                                  <p v-if="is_decrease_promo(data.price)" class="body-2 mb-0 text-12 text-orange text-line-through" :class="{'font-bold text-white':variant_selected.product_ga_pos_id == data.product_ga_pos_id}">{{formatCurrency(promotion_price(data.price))}}</p>
                                			<p class="body-2 mb-0 text-12 text-orange" :class="{'font-bold text-white':variant_selected.product_ga_pos_id == data.product_ga_pos_id}">{{formatCurrency(finalPrice(data.price))}}</p>
		                                </div>
		                              </div>
		                            </div>
		                          </div>
		                          <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: 0;" @click="xScroll('right', 'variant')">
		                            <img src="../../../../assets/img/icon/orange-arrow-right.png" width="18" class="next-button position-relative" style="right: -10px;top: 7px;z-index: 9">
		                          </div>
		                        </div>
		                      </div>
		                      <!-- Topping -->
		                      <!-- <div class="my-3 pt-2">
		                        <p class="mb-2 body-3-3 text-16 font-bold">Extra Additional</p>
		                        <div class="py-2 mb-1 cursor-pointer" @click="selectTopping(data.id)" v-for="(data, index) in topping">
		                          <div class="row slim-grid-row">
		                            <div class="col-11">
		                              <p class="body-2-2 mb-0 text-16 font-semibold">{{data.name}}</p>
		                              <p class="mb-0 ml-1 ls-0-1 text-12 text-light-menu text-line-through d-inline-block" v-if="data.discount < data.price">Rp. {{data.price}}</p>
		                              <p class="body-2 mb-0 text-14 text-orange d-inline-block">Rp. {{data.discount}}</p>
		                            </div>
		                            <div class="col-1 align-self-center">
		                              <div class="rounded-3 border-orange w-16px" :class="{'bg-orange':data.select}">
		                                <img src="../../../../assets/img/icon/correct-white.png" width="10" class="d-block" style="margin: 2px auto" v-if="data.select">
		                              </div>
		                            </div>
		                          </div>
		                        </div>
		                      </div> -->
		                    </div>
		                    <div class="height-75px"></div>
		                    <div class="position-relative" style="z-index: 1037">
		                      <div class="row no-gutters justify-content-center">
		                        <div class="fixed-bottom d-block nav-bottom" style="bottom:-10px">
		                          <div class="custom-container-fluid px-0">
		                            <div class="row justify-content-center no-gutters">
		                              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
		                                <div class="container px-4 pt-2 bg-white height-75px box-shadow-top">
		                                  <div class="row justify-content-center slim-grid-row">
		                                    <div class="col-4">
		                                      <div type="button" class="button-secondary bg-white w-100" style="cursor:auto;">
		                                        <img src="../../../../assets/img/icon/minus-orange.png" width="15" class="d-inline-block cursor-pointer" @click="changeQtyProduct('minus')">
		                                        <p class="mb-0 body-3-3-2 text-14 d-inline-block mx-2">{{counter}}</p>
		                                        <img src="../../../../assets/img/icon/plus-orange.png" width="15" class="d-inline-block cursor-pointer" @click="changeQtyProduct('plus')">
		                                      </div>
		                                    </div>
		                                    <div class="col-8">
		                                      <button type="button" class="button-secondary w-100 text-truncate px-4 text-12" style="height: 47px" @click="addToCart">
		                                      	<pulse-loader :loading="push_loader" color="#fff" v-if="push_loader"></pulse-loader>
		                                      	<template v-else>
			                                      	{{qtyCart == 0 ? 'Add to cart' : counter == 0 ? 'Cancel order' : 'Save change'}} <template v-if="counter > 0">- {{formatCurrency(total_price)}}</template>
			                                      </template>
		                                      </button>
		                                    </div>
		                                  </div>
		                                </div>
		                              </div>
		                            </div>
		                          </div>
		                        </div>
		                      </div>
		                    </div>
								    	</template>
								    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
  </div>
</template>
<script>
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
	import {mapGetters,mapMutations} from 'vuex';
	import {get} from '@/services/index.js';
	export default{
		props: {
			product_id: {
				type: String,
				default: ''
			},
			general_data: {
				type: Object,
				default: () => ({})
			}
		},
		data(){
			return{
				product: {},
				is_load: true,
				error: '',
				variant_selected: {},
				counter: 1,
				push_loader: false,
				show_popup: false
			}
		},
		computed:{
			isProductImageHidden(){
				return this.$isProductImageHidden(this.general_data)
			},
			is_product_ready(){
				return Object.keys(this.product).length > 0 ? true : false
			},
			is_variant(){
				return  this.is_product_ready && this.product.variant_list.length > 0 ? true : false
			},
			final_price(){
				let price = this.is_variant ? this.variant_selected.price : this.product.price
        return calculateFinalPriceConcierge(price)
      },
			total_price(){
				if(this.is_product_ready){
					return parseInt(this.counter) * parseInt(this.final_price)
					
				}else{
					return 0
				}
			},
			qtyCart(){
				let data = 0

				if(this.is_product_ready){
					let record = this.getConciergeOrder().cart.findIndex(x=>x.product.data.product_id == this.product_id)
					if(record != -1){
						if(this.is_variant){
							let record_variant = this.getConciergeOrder().cart[record].variant.findIndex(x=>x.data.product_ga_pos_id == this.variant_selected.product_ga_pos_id)
							if(record_variant != -1){
								data = this.getConciergeOrder().cart[record].variant[record_variant].qty
							}
						}else{
							data = this.getConciergeOrder().cart[record].qty
						}
					}

				}

				return data
			}
		},
		watch:{
			variant_selected:{
				deep: true,
				handler(){
					this.counter = this.qtyCart == 0 ? 1 : this.qtyCart
				}
			}
		},
		mounted(){
			this.getProductDetail()
		},
		methods:{
			...mapGetters(['getMerchant','getConciergeOrder','getConciergeReservation']),
			...mapMutations(['setConciergeOrder','removeConciergeOrder']),
			formatCurrency(value){
        return formatCurrency(value);
      },
      done(){
      	this.$emit('done',false)
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
      },
      is_decrease_promo(price){
        if(price.promotion_amount == 0){
          return false
        }else{
        	return price.promotion_type == 'INCREASE' ? false : true
        }
      },  
      finalPrice(price){
        return calculateFinalPriceConcierge(price)
      },
      promotion_price(price){
        if(price.promotion_amount == 0){
          return 0
        }else{
          return price.tax_service_calculation_type == 'INCLUDE' ? (price.price_sell_base) : price.price_sell
        }
      },
      changeQtyProduct(type){
      	if(!this.push_loader){
	        if(type == 'minus'){
	        	let comparison = this.qtyCart == 0 ? 1 : 0

	          if(this.counter > comparison){
	            this.counter--
	          }
	        }else{
	          this.counter++
	        }
      	}
      },
      addToCart(){
      	if(this.getConciergeReservation().status == 'CHECKIN'){
	      	if(!this.push_loader){
	      		this.push_loader = true
		      	let data = {
		      		product: this.product,
		      		variant: this.is_variant ? this.variant_selected : {},
		      		qty: this.counter
		      	}
		      	if(this.counter == 0){
		      		this.removeConciergeOrder(data)
		      	}else{
		      		this.setConciergeOrder(data)
		      	}
		      	setTimeout(()=>{
		      		this.push_loader = false
		      		this.done()
		      	},1000)
	      	}
	      }else{
	      	this.show_popup = true
	      }
      },
			getProductDetail(){
				this.product = {}
				this.is_load = true
				this.error = ''
				get("CONCIERGE","room-dining/product/"+this.product_id,{
					merchant_id: this.getMerchant().id
				}).then(response=>{
					let res = response.data
					if(res.success){
						this.product = res.data
						if(this.is_variant){
							this.variant_selected = res.data.variant_list[0]
						}
						this.counter = this.qtyCart == 0 ? 1 : this.qtyCart
					}else{
						this.error = res.message
					}
					this.is_load = false
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuDetail.vue